module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[111]232.e9bbfbe.woff2";